import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { useModal } from '@hooks/app/modal.hook'

import { Modal } from '@components/Modal'
import { Input } from '@components/Input'
import { Refresh } from '@components/Refresh'

import { useUser } from '@hooks/user/user.hook'
import { useUpdateUser } from '@hooks/user/update-user.hook'

import { Container } from './edit-user.styled'

export const EditUserPage = (): JSX.Element => {
  const { hideModal } = useModal()

  const { t } = useTranslation()

  const [searchParams] = useSearchParams()

  const userId = searchParams.get('userId')

  const { data, loading, error, refetch } = useUser(userId || '')

  const isLoading = loading ? 1 : error ? -1 : 0

  const user = data?.user

  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [email, setEmail] = useState<string>('')

  const { updateUser } = useUpdateUser()

  useEffect(() => {
    if (user) {
      setFirstName(user.firstName)
      setLastName(user.lastName)
      setEmail(user.email)
    }
  }, [user])

  return (
    <Modal
      title={t('modules_admin_pages_edit_user_title')}
      onSubmitLabel={t('modules_admin_pages_edit_user_button_edit-user')}
      onClose={() => {
        hideModal('update_user')
      }}
      onSubmit={() => {
        if (user) {
          updateUser({
            id: user.id,
            firstName,
            lastName,
            email,
          })
        }

        hideModal('update_user')
      }}
    >
      <Container>
        <Refresh small loading={isLoading} onRefresh={() => refetch(user?.id || '')}>
          <Input
            autoFocus
            required
            label={t('modules_admin_pages_edit_user_label_user-first_name')}
            placeholder={t('modules_admin_pages_edit_user_placeholder_user-first_name')}
            value={firstName}
            onChange={(v) => setFirstName(v)}
          />
          <Input
            required
            label={t('modules_admin_pages_edit_user_label_user-last_name')}
            placeholder={t('modules_admin_pages_edit_user_placeholder_user-last_name')}
            value={lastName}
            onChange={(v) => setLastName(v)}
          />
          <Input
            required
            type="email"
            label={t('modules_admin_pages_edit_user_label_user-email')}
            placeholder={t('modules_admin_pages_edit_user_placeholder_user-email')}
            value={email}
            onChange={(v) => setEmail(v)}
          />
        </Refresh>
      </Container>
    </Modal>
  )
}
